import getApiClient from '../../../plugins/api'

export default {
    setSearchStatus: function(status) {
        this.searchParams.status = status
    },

    changePage: function(page) {
        this.page = page
    },

    checkAccess: function() {
        const requestRole = 'ROLE_AGENCY',
            self = this

        let userRole = ''

        if (self.$store.state.user.roles) {
            userRole = self.$store.state.user.roles[0]
        }

        if (userRole !== requestRole) {
            // self.$router.push('/')
        }
    },

    setPlace: function(data) {
        this.searchParams['place.id'] = data.value
    },

    resetPlace: function() {
        this.searchParams['place.id'] = null
    },

    sortOrders: function(value) {
        this.orderDirection = value.asc ? 'asc' : 'desc'

        let column

        switch(value.column) {
            case 'date':
                column = 'timestamp'
            break
            case 'duration':
                column = 'trip.startTime'
            break
            default:
                column = value.column
        }

        this.orderColumn = column

        this.loadOrders()
    },

    loadOrders: function() {
        const self = this,
            api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        Object.keys(self.search).forEach((item) => self.search[item] = null);

        self.search['page'] = self.page
        self.search['itemsPerPage'] = self.perPage

        if (self.searchParams.futureTrips) {
            self.search['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.search['trip.startTime[before]'] = new Date()
        }

        if (self.searchParams.requestNumber) {
            self.search['id'] = self.searchParams.requestNumber
        }

        if (self.searchParams.agencyName) {
            self.search['trip.agency.name'] = self.searchParams.agencyName
        }

        if (self.searchParams.phone) {
            self.search['user.phone'] = self.searchParams.phone.replace(/[^\d]/g, '')
        }

        if (self.searchParams.name) {
            self.search['user.name'] = self.searchParams.name
        }

        if (self.searchParams.status) {
            self.search['status'] = self.searchParams.status
        }

        self.search['isFake'] = 0;

        if (self.searchParams.isFake) {
            self.search['isFake'] = 1
        }

        if (self.orderColumn && self.orderDirection) {
            self.search[`order[${self.orderColumn}]`] = self.orderDirection
        }

        if (self.searchParams['place.id']) {
            self.search['trip.place.id'] = self.searchParams['place.id']
        }

        api.get('agency/orders', {
            params: self.search
        })
            .then((result) => {
                self.orders = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    exportOrders: function() {
        const self = this,
          api = getApiClient(self.$root.$store)

        self.$store.commit('startLoading')

        Object.keys(self.search).forEach((item) => self.search[item] = null);

        self.search['page'] = self.page
        self.search['itemsPerPage'] = self.perPage

        if (self.searchParams.futureTrips) {
            self.search['trip.startTime[after]'] = new Date()
        }

        if (self.searchParams.pastTrips) {
            self.search['trip.startTime[before]'] = new Date()
        }

        if (self.searchParams.requestNumber) {
            self.search['id'] = self.searchParams.requestNumber
        }

        if (self.searchParams.agencyName) {
            self.search['trip.agency.name'] = self.searchParams.agencyName
        }

        if (self.searchParams.phone) {
            self.search['user.phone'] = self.searchParams.phone.replace(/[^\d]/g, '')
        }

        if (self.searchParams.name) {
            self.search['user.name'] = self.searchParams.name
        }

        if (self.searchParams.status) {
            self.search['status'] = self.searchParams.status
        }

        self.search['isFake'] = 0;

        if (self.searchParams.isFake) {
            self.search['isFake'] = 1
        }

        if (self.orderColumn && self.orderDirection) {
            self.search[`order[${self.orderColumn}]`] = self.orderDirection
        }

        if (self.searchParams['place.id']) {
            self.search['trip.place.id'] = self.searchParams['place.id']
        }

        api.get('/export_orders', {
              params: self.search
          },
          {
              responseType: 'blob'
          })
          .then((result) => {
              const blob = new Blob([result.data], { type: "text/csv" });
              const href = URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = href;
              link.setAttribute('download', 'Pedidos.csv');
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(href);
          })
          .catch((error) => {
              console.log(error)
          })
          .finally(() => {
              self.$store.commit('stopLoading')
          })
    },
}
